<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useUiStore } from '@/stores/ui';

const ui = useUiStore();
const { toasts } = storeToRefs(ui);
</script>

<template>
  <Teleport to="body">
    <div class="toast-host" role="status" aria-live="polite">
      <div v-for="toast in toasts" :key="toast.id" class="toast" :class="toast.kind">
        <div class="toast-body">
          <p class="toast-title">{{ toast.title }}</p>
          <p v-if="toast.message" class="toast-message">{{ toast.message }}</p>
        </div>
        <button type="button" aria-label="Đóng" @click="ui.dismissToast(toast.id)">×</button>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-host {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: min(420px, calc(100vw - 32px));
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--app-border);
  border-left-width: 3px;
  background: var(--app-surface);
  box-shadow: var(--app-shadow);
}

.toast.success {
  border-left-color: var(--app-success);
}
.toast.error {
  border-left-color: var(--app-danger);
}
.toast.warning {
  border-left-color: var(--app-warning);
}
.toast.info {
  border-left-color: var(--app-info);
}

.toast-body {
  flex: 1;
  min-width: 0;
}

.toast-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}

.toast-message {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--app-muted);
  overflow-wrap: anywhere;
  /* Validation failures list one rejected field per line; without this they
     collapse into a single run-on sentence. */
  white-space: pre-line;
}

button {
  border: none;
  background: transparent;
  color: var(--app-muted);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}
</style>
